import { Icon as i } from "../../../../../components/Icon/index.js";
import { SmartLink as n } from "../../../../../components/SmartLink/index.js";
import { dealActionItemStyle as l } from "../../../DealActionBar/style.js";
import { styled as r } from "styled-components";
import { Colors as t } from "../../../../../styles/colors/index.js";
import { Theme as o } from "../../../../../styles/themes/index.js";
const g = r(i)`
  color: rgb(${o.colors.Alpha});

  &[data-inactive='true'] {
    color: rgb(${t.Gray});
  }
`, f = r(
  n
)`
  ${l}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 16px 8px 12px;
  text-decoration: none;
  color: rgb(${o.colors.Alpha});

  i {
    font-size: 24px;
    margin-right: 4px;
  }

  &:hover {
    background-color: ${({ disabledClick: e }) => e ? `rgb(${o.colors.Juliet})` : `rgb(${o.colors.Kilo})`};
  }

  &[aria-disabled='true'] {
    color: rgb(${t.Gray});
  }
`;
export {
  g as DealActionBarCommentIcon,
  f as DealActionBarCommentLinkButton
};
